import { render, staticRenderFns } from "./UpdateGoodsDialog.vue?vue&type=template&id=fdbd466e&scoped=true&lang=pug&"
import script from "./UpdateGoodsDialog.vue?vue&type=script&lang=ts&"
export * from "./UpdateGoodsDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fdbd466e",
  null
  
)

export default component.exports